// RecordingListItem.js — Modern sidebar item
import React from "react";
import { Film, Volume2, Eye, CheckCircle2 } from "lucide-react";
import "./RecordingListItem.scss";

const formatDate = (dateStr) => {
  if (!dateStr) return "";
  return new Date(dateStr).toLocaleDateString("en-IN", {
    day: "numeric",
    month: "short",
    year: "numeric",
    timeZone: "Asia/Kolkata",
  });
};

const RecordingListItem = ({ rec, active, onClick, viewInfo }) => {
  const title = rec.topic || rec.title || "Recording";
  const date = rec.date || rec.recordedAt;

  return (
    <div
      className={`sidebar-item ${active ? "sidebar-item--active" : ""}`}
      onClick={onClick}
      role="button"
      tabIndex={0}
    >
      {/* Thumbnail */}
      <div className="sidebar-item__thumb">
        {rec.thumbnail || rec.thumbnailUrl ? (
          <img
            src={rec.thumbnail || rec.thumbnailUrl}
            alt={title}
            loading="lazy"
          />
        ) : (
          <div className="sidebar-item__thumb-placeholder">
            <Film />
          </div>
        )}
        {active && (
          <div className="sidebar-item__now-playing">
            <Volume2 />
          </div>
        )}
        {viewInfo?.viewed && !active && (
          <div className="sidebar-item__viewed-check">
            <CheckCircle2 size={14} />
          </div>
        )}
      </div>

      {/* Info */}
      <div className="sidebar-item__info">
        <div className="sidebar-item__title">{title}</div>
        <div className="sidebar-item__date">
          {formatDate(date)}
          {viewInfo?.viewCount > 0 && (
            <span className="sidebar-item__views">
              <Eye size={10} /> {viewInfo.viewCount}
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default RecordingListItem;
